import { AppAnimate, AppCard, AppGridContainer, AppInfoView } from "@crema";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Params, useParams } from "react-router-dom";
import { getLocationDetail } from "redux/actions/Master";
import { AppState } from "redux/store";
import LocationCreate from "./locationCreate";
import LocationHeader from "./locationHeader";

const LocationIndex: React.FC<{}> = () => { 
  const dispatch = useDispatch();
  const { id } = useParams<Readonly<Params>>();
  console.log(id);
  const { currentLocation } = useSelector<AppState, AppState["master"]>(
    ({ master }) => master
  );
  useEffect(() => {
    dispatch( getLocationDetail(+id! as number));
  }, [dispatch, id]);

  return (
    <>
      {currentLocation ? (
        <AppAnimate animation="transition.slideUpIn" delay={200}>
          <AppCard>
          <LocationHeader location={currentLocation} />
          <div>Location ID: {id}</div>
             <AppGridContainer>
              <LocationCreate Location={currentLocation} />
            </AppGridContainer>
          </AppCard>
        </AppAnimate>
      ) : null}
      <AppInfoView />
    </>
  );
};

export default LocationIndex;
